module.exports = __webpack_public_path__ + "static/media/mi-liga-2.db573ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/mi-liga-2.png
// module id = 295
// module chunks = 0